(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentDocumentDetailController',ShipmentDocumentDetailController);

    ShipmentDocumentDetailController.$inject = ['$scope','$rootScope','$stateParams','previousState','entity',
        'RequiredDocumentCustomService','AttachmentCustomService','MiscService','ToastrService'];

    function ShipmentDocumentDetailController($scope, $rootScope, $stateParams, previousState, entity,
                                              RequiredDocumentCustomService, AttachmentCustomService, MiscService, ToastrService) {
        var vm = this;

        vm.shipmentDocument = entity;
        vm.previousState = previousState.name;
        vm.nl2br = MiscService.nl2br;
        vm.showApproved = showApproved;
        vm.downloadAttachment = downloadAttachment;
        vm.purchaseInvoice = null;
        vm.saleInvoice = null;
        vm.icInvoice = null;
        vm.bl = null;
        vm.pl = null;
        vm.phyto = null;
        vm.co = null;
        vm.fumigation = null;

        vm.convertBoolean = convertBoolean;

        fetchRequiredDocuments();

        var unsubscribe = $rootScope.$on('ccsTrApp:shipmentDocumentUpdate', function(event,result) {
            vm.shipmentDocument = result;
        });
        $scope.$on('$destroy',unsubscribe);

        function convertBoolean(bool) {
            return bool === true ? 'Required' : 'Not Required';
        }

        function fetchRequiredDocuments() {
            if(vm.shipmentDocument.purchaseInvoice) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"PURCHASEINVOICE").then(function(data) {
                    vm.purchaseInvoice = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
            if(vm.shipmentDocument.saleInvoice) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"SALEINVOICE").then(function(data) {
                    vm.saleInvoice = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
            if(vm.shipmentDocument.icInvoice) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"ICINVOICE").then(function(data) {
                    vm.icInvoice = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
            if(vm.shipmentDocument.bl) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"BL").then(function(data) {
                    vm.bl = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
            if(vm.shipmentDocument.pl) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"PL").then(function(data) {
                    vm.pl = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
            if(vm.shipmentDocument.phyto) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"PHYTO").then(function(data) {
                    vm.phyto = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
            if(vm.shipmentDocument.co) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"CO").then(function(data) {
                    vm.co = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
            if(vm.shipmentDocument.fumigation) {
                RequiredDocumentCustomService.getFullRequiredDocumentByShipmentDocumentIdAndType(vm.shipmentDocument.id,"FUMIGATION").then(function(data) {
                    vm.fumigation = data.data;
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Cannot fetch Required Documents ", "Error");
                    }
                });
            }
        }

        function showApproved(value) {
            return value !== null;
        }

        function downloadAttachment(attachment) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot download Attachment: " + error.statusText, "Error");
                }
            });
        }
    }
})();
